import { Component } from '@angular/core';

@Component({
    selector: 'app-why-choose-us',
    templateUrl: './why-choose-us.component.html',
    styleUrls: ['./why-choose-us.component.scss'],
    standalone: true
})
export class WhyChooseUsComponent {

}
